import {Inbox, SearchX} from 'lucide-react';
import {DiibsIcon} from '../components/common/DiibsIcon';

interface Iprops {
  searchKeyword?: any;
  clearSearch?: any;
  filters?: any;
  data?: any;
}

export default function NotFound({searchKeyword, clearSearch, filters}: Iprops) {
  const isFiltered = !!(searchKeyword || filters);

  return (
    <div className='d-flex flex-column align-items-center justify-content-center py-16 px-4 text-center'>
      <span className='d-flex align-items-center justify-content-center rounded-circle bg-light mb-5'
        style={{width: 72, height: 72}}>
        {isFiltered
          ? <DiibsIcon icon={SearchX} size={32} className='text-muted' />
          : <DiibsIcon icon={Inbox} size={32} className='text-muted' />
        }
      </span>

      <h4 className='fw-bold text-gray-800 mb-2'>
        {isFiltered ? 'No matching records' : 'Nothing here yet'}
      </h4>

      <p className='text-muted fs-6 mb-0' style={{maxWidth: 320}}>
        {isFiltered
          ? `No results found${searchKeyword ? ` for "${searchKeyword}"` : ''}. Try adjusting your search or filters.`
          : 'Records will appear here once they are created.'}
      </p>

      {isFiltered && clearSearch && (
        <button
          className='btn btn-sm btn-light-primary mt-5'
          onClick={clearSearch}
        >
          Clear {searchKeyword ? 'search' : 'filters'}
        </button>
      )}
    </div>
  );
}
